import { render } from "./PRR.vue?vue&type=template&id=a6447f9e&scoped=true"
import script from "./PRR.vue?vue&type=script&lang=js"
export * from "./PRR.vue?vue&type=script&lang=js"

import "./PRR.vue?vue&type=style&index=0&id=a6447f9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6447f9e"]])

export default __exports__